import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../../../react-hooks/use-services.hook";
import {SuggestedVideoSlidesFilterItemPreviewBox} from "./boxes/suggested-video-slides-filter-item-preview/suggested-video-slides-filter-item-preview.box";
import {SuggestedVideoSlidesFilterItemPreviewPlayerBox} from "./boxes/suggested-video-slides-filter-item-preview-player/suggested-video-slides-filter-item-preview-player.box";
import {ISearchSuggestion} from "../../../../../../services/game-search/game-search-result";
import {SuggestedVideoSlidesFilterItemPreviewFooterBox} from "./boxes/suggested-video-slides-filter-item-preview-footer/suggested-video-slides-filter-item-preview-footer.box";
import {SuggestedVideoSlidesFilterItemPreviewFooterTextBox} from "./boxes/suggested-video-slides-filter-item-preview-footer-text/suggested-video-slides-filter-item-preview-footer-text.box";

interface SuggestedVideoSlidesFilterItemPreviewProps {
    videoSlidesFilterPreviewSuggestion: ISearchSuggestion;
    filterCount: number;
}
export const SuggestedVideoSlidesFilterItemPreviewComponent: React.FC<SuggestedVideoSlidesFilterItemPreviewProps> = observer((props) => {
    const services = useServices();
    
    return (<SuggestedVideoSlidesFilterItemPreviewBox
        filterCount={props.filterCount}
        onClick={() => {props.videoSlidesFilterPreviewSuggestion.executeAction()}}
    >
        <SuggestedVideoSlidesFilterItemPreviewPlayerBox
            gameInfo={props.videoSlidesFilterPreviewSuggestion.gameInfo}
            muted={true}
            onError={() => {}} //TODO we will have a task for videoPlayer
            onLoading={() => {}}
            onWatchTimeLimitReached={() => {}}
            isInCenterStage={true}
            inViewport={true}
            display={true}
            videoPlayingService={services.videoOnDemandPlaying}
            loop={true}
        />
        <SuggestedVideoSlidesFilterItemPreviewFooterBox>
            <SuggestedVideoSlidesFilterItemPreviewFooterTextBox>
                {props.videoSlidesFilterPreviewSuggestion.text}
            </SuggestedVideoSlidesFilterItemPreviewFooterTextBox>
        </SuggestedVideoSlidesFilterItemPreviewFooterBox>

    </SuggestedVideoSlidesFilterItemPreviewBox>)
})